
const getShortCustomerName = (fullName = '') => {
  const nameParts = fullName.split(' ');
  if (nameParts.length < 2) {
    return fullName;
  }
  return `${nameParts[0]} ${nameParts[1].substr(0, 1)}.`;
};

export default getShortCustomerName;
